/* eslint-disable no-unused-vars */
export enum homeConstant {
  GET_CATEGORY = 'GET_CATEGORY',
  UPDATE_CATEGORY_ID = 'UPDATE_CATEGORY_ID',
  GET_NOTIFICATION = 'GET_NOTIFICATION',
  UPDATE_STATE_NOTIFICATION = 'UPDATE_STATE_NOTIFICATION',
  MARK_AS_READ_NOTIFICATION = 'MARK_AS_READ_NOTIFICATION',
  UPDATE_STATE_MARK_AS_READ_NOTIFICATION = 'UPDATE_STATE_MARK_AS_READ_NOTIFICATION',
  UPDATE_SHOW_TERMS_STATUS = 'UPDATE_SHOW_TERMS_STATUS',
}
